<template>
<div id="main">
  <div class="clearfix">
    <div class="fl main-sider">
      <Sider/>
    </div>
    <div id="main-content" :class="sidebarState? 'main-content-open':'main-content-close'">
      <HeaderView/>
      <div class="content_bg">
        <TabsView/>
        <div class="auto-bg">
          <!-- <transition name="fade-transform" mode="out-in">
          </transition> -->
          <keep-alive :include="cachedRouteNameList">
            <router-view :key="$route.fullPath" v-if="isRouterShow"></router-view>
          </keep-alive>
        </div>
      </div>
    </div>
  </div>
  <el-backtop target=".auto-bg" :bottom="94">
    <i class="backtop-icon el-icon-caret-top"></i>
    <div>回到<br/>顶部</div>
  </el-backtop>
</div>
</template>

<script>
import $ from 'jquery'
import HeaderView from './Public/Header.vue'
import Sider from './Public/Sider.vue'
import TabsView from './Public/Tabs.vue'
export default {
  name: 'Home',
  components: {
    HeaderView,
    Sider,
    TabsView
  },
  mounted () {
    this.handleBackTopShow()
  },
  provide () {
    return {
      reload: this.reload
    }
  },
  computed: {
    cachedRouteNameList () {
      return this.$store.state.Tabs.cachedRouteNameList
    }
  },
  created () {
    // 打印是否登录
    console.log(this.$store.state.Auth.sign, 1)
  },
  watch: {
    $route (to, from) {
    }
  },
  data () {
    return {
      timer: null,
      sidebarState: this.$store.state.Auth.sidebarState,
      isRouterShow: true
    }
  },
  methods: {
    // 返回顶部按钮展示2秒自动消失
    handleBackTopShow () {
      $('.auto-bg').scroll(() => {
        clearTimeout(this.timer)
        let scrollTop = $('.auto-bg').scrollTop()
        if (scrollTop >= 200) {
          $('.el-backtop').show()
          this.timer = setTimeout(() => {
            $('.el-backtop').fadeOut()
          }, 2000)
        } else {
          $('.el-backtop').fadeOut()
        }
      })
    },
    // 刷新当前页面 供其他页面使用
    reload () {
      this.isRouterShow = false
      this.$nextTick(() => {
        this.$store.commit('deleteCacheRoute', this.$route)
        this.isRouterShow = true
      })
    }
  }
}
</script>

<style lang="less" scoped>
.el-backtop{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 54px;
  height: 54px;
  background-color: #f2f5f6;
  font-size: 12px;
  color: #1989fa;
  line-height: 14px;
  box-shadow: 2px 2px 6px rgba(0,0,0,0.3);
  .backtop-icon{
    position: absolute;
    top: 2px;
  }
}
#main {
  background-color: #EBEEF5;
  min-width: 1200px;
}
.main-sider {
  background: #273543;
}
#main-content {
  transition: all .5s;
  height: 100vh;
}
.main-content-open {
  margin-left: 0px;
  overflow: hidden;
}
.main-content-close {
  margin-left: 0px;
  overflow: hidden;
}
.content_bg {
  // background: #F2F6FC;
  // background: #EBEEF5;
}
.auto-bg{
  margin: 20px;
  background: #fff;
  height: calc(100vh - 154px);
  overflow: hidden;
  overflow-y: auto;
  width: calc(100% - 40px);
  box-sizing: border-box;
  padding: 0 20px 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue